var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import CarCrashOutlinedIcon from "@mui/icons-material/CarCrashOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import { Avatar, Box, Button, Divider, IconButton, Stack, Typography, } from "@mui/material";
import { useEffect, useState } from "react";
import { CategoryEnum } from "../../types/categorias.type";
import { Colors } from "../../util/theme";
export var ItemServico = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, goTo = _a.goTo, category = _a.category, isDisabled = _a.isDisabled;
    var navigate = useNavigate();
    var _b = useState(_jsx(BadgeOutlinedIcon, {})), icon = _b[0], setIcon = _b[1];
    useEffect(function () {
        switch (category) {
            case CategoryEnum.HABILITACAO:
                setIcon(_jsx(BadgeOutlinedIcon, {}));
                break;
            case CategoryEnum.VEICULOS:
                setIcon(_jsx(DirectionsCarFilledOutlinedIcon, {}));
                break;
            case CategoryEnum.INFRACOES:
                setIcon(_jsx(CarCrashOutlinedIcon, {}));
                break;
            default:
                setIcon(_jsx(BadgeOutlinedIcon, {}));
                break;
        }
    }, [category]);
    return (_jsxs(Stack, __assign({ width: "100%" }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", py: "0.5rem" }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: "0.5rem" }, { children: [_jsx(Avatar, __assign({ sx: {
                                    backgroundColor: Colors.AZUL_GOV,
                                    padding: "0.5rem",
                                } }, { children: icon })), _jsxs(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "start" }, { children: [_jsx(Typography, __assign({ mt: 1, fontSize: "1rem", fontWeight: 500 }, { children: title })), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: subtitle })), _jsx(Button, __assign({ variant: "text", onClick: function () { return navigate(goTo); }, sx: { color: Colors.AZUL_GOV, padding: "0" }, disabled: isDisabled }, { children: "ACESSAR" }))] }))] })), _jsx(IconButton, __assign({ onClick: function () { return navigate(goTo); }, disabled: isDisabled }, { children: _jsx(ArrowForwardIosOutlinedIcon, { sx: { color: "#757575" } }) }))] })), _jsx(Divider, {})] })));
};
